import { render, staticRenderFns } from "./BooleanTag.vue?vue&type=template&id=216d5c7d"
import script from "./BooleanTag.vue?vue&type=script&lang=js"
export * from "./BooleanTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports